import React, {useMemo} from "react"
import {SchoolClass, SchoolClassCheckIn, ScoreFactorGroup} from "models"
import {ShapeComponent, shapeComponent} from "set-state-compare/build/shape-component"
import currentDate from "shared/current-date"
import memo from "set-state-compare/build/memo"
import moment from "shared/moment"
import PageContentsPresentation from "components/page-contents/presentation"
import PropTypes from "prop-types"
import propTypesExact from "prop-types-exact"
import ScoreFactorChartSlide from "components/user/school-classes/insights/score-factor-chart-slide"
import {View} from "react-native"

/**
 * @typedef {object} RoutesUserSchoolClassesSchoolClassCheckInsSide3Props
 * @property {unknown} developmentScoreFactorGroup
 * @property {unknown} refreshVersion
 * @property {unknown} schoolClass
 * @property {unknown} schoolClassCheckIn
 */

/** @typedef {object} RoutesUserSchoolClassesSchoolClassCheckInsSide3State */

/**
 * @extends {ShapeComponent<RoutesUserSchoolClassesSchoolClassCheckInsSide3Props, RoutesUserSchoolClassesSchoolClassCheckInsSide3State>}
 */
class RoutesUserSchoolClassesSchoolClassCheckInsSide3 extends ShapeComponent {
  static propTypes = propTypesExact({
    developmentScoreFactorGroup: PropTypes.instanceOf(ScoreFactorGroup),
    refreshVersion: PropTypes.string.isRequired,
    schoolClass: PropTypes.instanceOf(SchoolClass).isRequired,
    schoolClassCheckIn: PropTypes.instanceOf(SchoolClassCheckIn).isRequired
  })

  setup() {
    this.dateFrom = useMemo(() => moment().subtract(4, "weeks").startOf("day").toDate(), [])
    this.dateTo = useMemo(() => moment(currentDate()).endOf("day").toDate(), [])
  }

  render() {
    const {developmentScoreFactorGroup, schoolClass, schoolClassCheckIn} = this.p

    return (
      <View dataSet={{component: "routes--user--school-classes--school-class-check-ins--slide-3"}}>
        <PageContentsPresentation
          identifier="user/school-classes/school-class-check-ins/slide-3"
          liquidVariables={{schoolClass, schoolClassCheckIn}}
        />
        <ScoreFactorChartSlide
          dateFrom={this.tt.dateFrom}
          dateTo={this.tt.dateTo}
          refreshVersion={this.p.refreshVersion}
          schoolClass={schoolClass}
          scoreFactorGroup={developmentScoreFactorGroup}
        />
      </View>
    )
  }
}

export default memo(shapeComponent(RoutesUserSchoolClassesSchoolClassCheckInsSide3))
